import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AltroComponent } from './altro.component';



@NgModule({
  declarations: [AltroComponent],
  imports: [
    CommonModule
  ],
  exports:[AltroComponent]
})
export class AltroModule { }
